import React from "react";
import styles from "../styles/QFilters.module.css";

function MenuVertical({
    options,
    multiple,
    val,
    onChange,
    styles_parsed,
    alignItems,
    direction = "h",
}) {
    const textAlign =
        alignItems === "flex-start"
            ? "left"
            : alignItems === "flex-end"
            ? "right"
            : alignItems;
    return (
        <div
            style={{
                display: "flex",
                justifyContent: alignItems,
                width: "100%",
            }}
        >
            <ul
                style={{
                    listStyle: "none",
                    padding: 0,
                    width: direction === "v" ? "100%" : "auto",
                    margin: 0,
                }}
            >
                {options.map((option, index) => {
                    if (option.label === "") {
                        return <></>;
                    }
                    const is_selected = multiple
                        ? val.includes(option.value)
                        : val === option.value;

                    return (
                        <li
                            key={index}
                            className={styles.chips}
                            style={{
                                // display: "inline-block",
                                display:
                                    direction === "h"
                                        ? "inline-block"
                                        : "block",
                                paddingLeft: "10px",
                                paddingRight: "10px",
                                cursor: "pointer",
                                ...styles_parsed.normal,
                                ...(is_selected ? styles_parsed.selected : {}),
                                textAlign: textAlign,
                            }}
                            onClick={() => onChange(option.value, index)}
                        >
                            {option.label}
                        </li>
                    );
                })}
            </ul>
        </div>
    );
}

export default MenuVertical;
